"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Brand = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _compat = babelHelpers.interopRequireDefault(require("compat"));

var _decorators = require("decorators");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _ProductGroup = require("pages/ProductGroup");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _temp, _class3, _descriptor11, _temp2;

var Brand = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Brand, _Component);

  function Brand(props) {
    var _this;

    babelHelpers.classCallCheck(this, Brand);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Brand).call(this, props));
    babelHelpers.initializerDefineProperty(_this, "backgroundImage", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "backgroundImagePortrait", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "imageOverlay", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "brandName", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "logo", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "headerImage", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "summary", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "description", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "brandWebsite", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "products", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.sorts = {
      mostPopular: {
        title: 'Most Popular',
        sort: function sort(left, right) {
          if (left.order.orderCount == right.order.orderCount) return left.order.index - right.order.index;
          return right.order.orderCount - left.order.orderCount;
        }
      },
      priceAsc: {
        title: 'Price Low to High',
        sort: function sort(left, right) {
          return left.order.itemPrice - right.order.itemPrice;
        }
      },
      priceDesc: {
        title: 'Price High to Low',
        sort: function sort(left, right) {
          return right.order.itemPrice - left.order.itemPrice;
        }
      },
      alpha: {
        title: 'A-Z',
        sort: function sort(left, right) {
          return left.title < right.title ? -1 : 1;
        }
      },
      reverseAlpha: {
        title: 'Z-A',
        sort: function sort(left, right) {
          return left.title < right.title ? 1 : -1;
        }
      }
    };
    _this.state = {
      order: 'mostPopular'
    };

    if (props.products) {
      var p = props.products.slice();
      p.sort(_this.sorts[_this.state.order].sort);
      _this.state.sortedProducts = p;
    }

    return _this;
  }

  babelHelpers.createClass(Brand, [{
    key: "sortProducts",
    value: function sortProducts() {
      if (this.props.products) {
        var p = this.props.products.slice();
        p.sort(this.sorts[this.state.order].sort);
        this.setState({
          sortedProducts: p
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.backgroundImage != this.backgroundImage || prevProps.headerImage != this.headerImage || prevProps.backgroundImagePortrait != this.backgroundImagePortrait || prevProps.imageOverlay != this.imageOverlay) {
        this._style = null;
      }

      if (prevProps.products != this.props.products || this.state.order != prevState.order) {
        this.sortProducts();
      }
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      if (this._style) return this._style;
      var backgroundImage = this.headerImage || this.backgroundImage;

      if (_compat.default && _compat.default.cssVariables) {
        var backgroundImage = this.headerImage || this.backgroundImage;
        var bgPortrait = this.headerImage || this.backgroundImagePortrait || this.backgroundImage;
        return this._style = {
          '--landscape-background': "url(".concat(backgroundImage, ")"),
          '--portrait-background': "url(".concat(bgPortrait, ")"),
          '--landscape-600px-background': "url(/t/width=600/scale/f".concat(backgroundImage, "/scaled.jpg)"),
          '--portrait-600px-background': "url(/t/width=600/scale/f".concat(bgPortrait, ".jpg)"),
          'backgroundImage': 'var(--image-overlay), var(--selected-background)'
        };
      }

      return this._style = {
        'backgroundImage': "".concat(this.imageOverlay, ", url(").concat(backgroundImage, ")")
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "block stack header-block height-60vh",
        "data-block-type": "header"
      }, _react.default.createElement("div", {
        className: _classList.default.join('spotlight-header', _compat.default && _compat.default.cssVariables && this.backgroundImage ? 'variable-background' : ''),
        style: this.getStyle()
      }, _react.default.createElement("div", {
        className: "inner-content animate-fadeIn",
        style: {
          paddingRight: 0
        }
      }, _react.default.createElement("div", {
        className: "brand-detail-header"
      }, _react.default.createElement("div", {
        className: "image-container"
      }, _react.default.createElement("div", {
        className: "logo",
        style: {
          backgroundImage: "url(/t/color-top-left/trim/f".concat(this.logo, "/logo.png)")
        }
      })), _react.default.createElement("h1", {
        style: {
          textAlign: 'center'
        }
      }, this.brandName), this.summary && _react.default.createElement("h2", {
        style: {
          textAlign: 'center'
        }
      }, this.summary))))), (this.description || this.brandWebsite) && _react.default.createElement("div", {
        className: "block stack text height-auto",
        "data-block-type": "freeformText"
      }, _react.default.createElement("div", {
        className: "inner-content container"
      }, this.description && _react.default.createElement("div", {
        className: "description",
        dangerouslySetInnerHTML: {
          __html: this.description
        }
      }), this.brandWebsite && _react.default.createElement("div", {
        style: {
          width: '100%',
          textAlign: 'center'
        }
      }, _react.default.createElement("a", {
        href: this.brandWebsite,
        target: "_blank",
        className: "btn btn-primary",
        style: {
          margin: '50px auto 0 auto'
        }
      }, "Visit Site")))), this.products.length && _react.default.createElement("div", {
        className: "block stack catalog-group height-auto",
        "data-block-type": "contentGroup"
      }, _react.default.createElement("div", {
        className: "inner-content"
      }, this.products.length > 1 && _react.default.createElement("div", {
        className: "card-container card-grid"
      }, _react.default.createElement("div", {
        className: "sort-header"
      }, _react.default.createElement("div", {
        className: "input-group-btn dropdown sort-button"
      }, _react.default.createElement("button", {
        className: "btn dropdown-toggle",
        "data-toggle": "dropdown"
      }, _react.default.createElement("span", null, "Sort ", _react.default.createElement("span", {
        className: "caret"
      }))), _react.default.createElement("ul", {
        className: "dropdown-menu dropdown-menu-right"
      }, Object.keys(this.sorts).map(function (key) {
        return _react.default.createElement("li", {
          key: key,
          className: key == _this2.state.order ? 'active' : ''
        }, _react.default.createElement("a", {
          href: "javascript:void(0)",
          onClick: _this2.setOrder,
          "data-order": key
        }, _this2.sorts[key].title));
      }))))), _react.default.createElement("div", {
        className: "card-container card-centered card-grid"
      }, (this.state.sortedProducts || this.products).map(function (_ref) {
        var card = _ref.card;
        return _react.default.createElement(require(card.child_type).default, babelHelpers.objectSpread({
          key: card.id
        }, card));
      })))));
    }
  }, {
    key: "setOrder",
    value: function setOrder(_ref2) {
      var order = _ref2.target.dataset.order;
      this.setState({
        order: order
      });
    }
  }]);
  return Brand;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "backgroundImage", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "backgroundImagePortrait", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "imageOverlay", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "brandName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "logo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "headerImage", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "description", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "brandWebsite", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "products", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setOrder", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setOrder"), _class.prototype)), _class);
exports.Brand = Brand;
var BrandWrapper = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(BrandWrapper, _Component2);

  function BrandWrapper() {
    var _babelHelpers$getProt;

    var _this3;

    babelHelpers.classCallCheck(this, BrandWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(BrandWrapper)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "content", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(BrandWrapper, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        id: "page-content-container"
      }, _react.default.createElement("div", {
        "data-brand-page": "true"
      }, _react.default.createElement(Brand, this.content)));
    }
  }]);
  return BrandWrapper;
}(_react.Component), _temp2), (_descriptor11 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.default = BrandWrapper;